<template>
  <div :id="componentId" class="spm6-hero-section" :style="{ backgroundColor: bgColor }">
    <div class="spm6-hero-block">
      <img class="spm6-hero-image" referrerpolicy="no-referrer" :src="imageUrl" />
      <div class="spm6-hero-text">
        <div class="spm6-hero-title-row">
          <div class="spm6-hero-title-line"></div>
          <span class="spm6-hero-title">{{ title }}</span>
          <div class="spm6-hero-title-line"></div>
        </div>
        <span class="spm6-hero-content">{{ contentWithIndent }}</span>
      </div>
    </div>
    <div class="spm6-hero-bg" :style="{ backgroundImage: `url(${bgImageUrl})` }"></div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeroSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_2'
    }
  },
  data() {
    return {
      title: '武\u00A0汉',
      content: '作为宁德核电党委书记、董事长、总经理，田辉宇同志始终牢记嘱托，胸怀"两个大局"，牢记"国之大者"，坚决贯彻落实习近平新时代中国特色社会主义思想，充分发挥企业负责人率先垂范作用，带领公司广大员工奋力拼搏，保障核电安全稳定运营，持续输出绿色清洁能源，为国家双碳目标作出积极贡献。',
      imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNGfcc2d8c3ac5a2e301e5bff2331c0665b.png'),
      bgImageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG2e04ab22b8b64c961356885edaae1bea.png'),
      bgColor: '#F3F3F3'
    }
  },
  computed: {
    contentWithIndent() {
      return '\u3000\u3000' + (this.content || '')
    }
  }
}
</script>

<style scoped>
.spm6-hero-section {
  width: 100%;
  padding: 16px 12px 0;
  box-sizing: border-box;
}

.spm6-hero-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spm6-hero-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
}

.spm6-hero-text {
  width: 100%;
}

.spm6-hero-bg {
  width: 100%;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100% 100%;
}

.spm6-hero-title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.spm6-hero-title-line {
  width: 20px;
  height: 4px;
  background: #E60012;
  border-radius: 2px;
}

.spm6-hero-title {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
}

.spm6-hero-content {
  font-size: 13px;
  color: #333;
  line-height: 22px;
  display: block;
}
</style>
